import { ReactNode } from "react";

interface StatsCardContainerProps {
  children: ReactNode;
}

export function StatsCardContainer({ children }: StatsCardContainerProps) {
  return <div className='flex w-full bg-white border rounded-md overflow-hidden'>{children}</div>;
}

interface StatsCardItemProps {
  title: string;
  value: string | number;
  isLast?: boolean;
}

export function StatsCardItem({ title, value, isLast = false }: StatsCardItemProps) {
  return (
    <div className='flex-1 py-4 px-6 flex justify-center items-center relative'>
      <div className='z-10'>
        <h3 className='text-xs text-(--gray-3) mb-2'>{title}</h3>
        <p className='text-xl font-normal'>{value}</p>
      </div>
      {!isLast && <div className='absolute h-[50px] w-[1px] right-0 top-1/2 -translate-y-1/2 bg-gray-200'></div>}
    </div>
  );
}
